let Page   = require('../mixins/base-page');
let Search = require('../mixins/base-search');

module.exports = {
	mixins: [Page, Search],

	props: {
		loadTab: {
			type: String,
			default: 'lessons'
		}
	},

	data() {
		return {
			activeTab: this.loadTab,
			tabTypes: [
				'lessons',
				'courses',
				'series'
			],
			searchResults: {
				lessons: false,
				courses: false,
				series: false,
				lessonsPagination: false,
				coursesPagination: false,
				seriesPagination: false
			}
		}
	},

	computed: {
		loadComplete() {
			return this.searchResults.lessons !== false
				&& this.searchResults.courses !== false
				&& this.searchResults.series !== false;
		}
	},

	watch: {
		searchResults: {
			handler: function() {
				this.handleSearchResultsUpdate();
			},
			deep: true
		}
	},

	methods: {
		search() {
			// disable search as we are using grids
		},

		coursesLoaded(items, pagination) {
			this.searchResultsLoaded('courses', items, pagination);
		},

		lessonsLoaded(items, pagination) {
			this.searchResultsLoaded('lessons', items, pagination);
		},

		seriesLoaded(items, pagination) {
			this.searchResultsLoaded('series', items, pagination);
		},

		searchResultsLoaded(type, loaded, pagination) {
			this.searchResults[type] = loaded;
			this.searchResults[type + 'Pagination'] = pagination;
		},

		handleSearchResultsUpdate() {
			if(this.loadComplete) {
				this.searching = false;
				this.loadingSearch = false;
			} else if(!this.loadingSearch) {
				this.searching = true;
			}
		}
	}
};
